import React from "react";
import { Link } from "react-router-dom";

// Image
import CVAnalyserImage from "../../assets/cv_analyser.png";

const CVTracker = () => {
    return (
        <>
        <style>{`
            @media (max-width: 768px) {
                .cv-tracker-section-mobile {
                    overflow: visible !important;
                    padding-top: 0 !important;
                }
                .cv-tracker-image-mobile {
                    order: 1 !important;
                    margin-bottom: 2rem !important;
                    margin-top: -1rem !important;
                    z-index: 10 !important;
                    position: relative !important;
                }
                .cv-tracker-content-mobile {
                    order: 2 !important;
                    text-align: left !important;
                    padding-left: 0 !important;
                    margin-left: 0 !important;
                }
                .cv-tracker-content-mobile p,
                .cv-tracker-content-mobile h2 {
                    text-align: left !important;
                    padding-left: 0 !important;
                    margin-left: 0 !important;
                }
                .cv-tracker-content-mobile h2 {
                    margin-top: 1rem !important;
                }
                .cv-tracker-paragraph-mobile {
                    text-align: left !important;
                    padding-left: 0 !important;
                    margin-left: 0 !important;
                }
                .cv-tracker-section-mobile {
                    padding-left: 1rem !important;
                }
            }
        `}</style>
        <section id="cv-analyser" className="w-full py-16 px-4 md:px-8 bg-white cv-tracker-section-mobile">
            <div className="max-w-7xl mx-auto rounded-lg overflow-hidden">
                <div className="flex flex-col md:flex-row items-stretch h-full">
                    {/* Mobile: Content second, Desktop: Content first */}
                    <div className="w-full md:w-1/2 pr-0 md:pr-12 mb-12 md:mb-0 cv-tracker-content-mobile">
                        <p className="text-sm text-gray-600 mb-2 mt-4">AI-Powered CV Analyser</p>
                        <h2 className="text-[24px] md:text-4xl md:font-sans mb-4 md:mb-12">
                            Not Getting Interviews? Your CV Might Be Holding You Back.
                        </h2>
                        <p className="text-[16px] md:text-base mb-6 md:mb-12 cv-tracker-paragraph-mobile">
                            Upload your CV and receive instant, actionable feedback. Tailored for medical professionals, our analyser identifies weak points, gaps, and misalignments, then recommends improvements based on your specialty and goals.
                        </p>
                        <Link 
                            to="/signup"
                            className="inline-block bg-black text-white py-2 px-4 rounded-3xl hover:bg-gray-800 transition-colors"
                        >
                            Get Your Free CV Analysis
                        </Link>
                    </div>

                    {/* Mobile: Image first, Desktop: Image second */}
                    <div className="w-full md:w-1/2 rounded-3xl bg-[#E5F0F0] p-8 flex items-center justify-center cv-tracker-image-mobile">
                        <div className="w-96 rounded-lg overflow-hidden">
                            <img
                                src={CVAnalyserImage}
                                alt="CV Analyser"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default CVTracker;
